"use client";

import { setSessionExpiredHandler } from "@onsand/api";
import { useEffect } from "react";
import { usePathname } from "@/i18n/navigation";
import { PUBLIC_PATHS } from "@/lib/public-paths";
import { signOutAndGoToLogin } from "@/lib/sign-out";

/**
 * Sends the visitor to the login once the API refuses their session for good (a 401 that a
 * token refresh could not fix). Stands down on the public pages: /login has no session to lose.
 */
export function SessionExpiryGuard() {
	const pathname = usePathname();

	useEffect(() => {
		if (PUBLIC_PATHS.includes(pathname)) return;
		setSessionExpiredHandler(() => void signOutAndGoToLogin());
		return () => setSessionExpiredHandler(null);
	}, [pathname]);

	return null;
}
